// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listFiles_File__KaQBJ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
}
.listFiles_NameFile__9t0G- {
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
}`, "",{"version":3,"sources":["webpack://./src/entities/listFiles/ui/listFiles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ","sourcesContent":[".File {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 5px;\n}\n.NameFile {\n    user-select: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"File": `listFiles_File__KaQBJ`,
	"NameFile": `listFiles_NameFile__9t0G-`
};
export default ___CSS_LOADER_EXPORT___;
